import { render, staticRenderFns } from "./DSIcon.vue?vue&type=template&id=f75b51b0&scoped=true&"
import script from "./DSIcon.vue?vue&type=script&lang=ts&"
export * from "./DSIcon.vue?vue&type=script&lang=ts&"
import style0 from "./DSIcon.vue?vue&type=style&index=0&id=f75b51b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75b51b0",
  null
  
)

export default component.exports